// Dev 模式服务器配置
const vueDevConfig = {
    host: 8081, // 更改需重启 Dev 服务器
    useEslint: false,  // 是否启动代码检查 
    autoOpenBrowser: true

}

// Build 模式服务器配置
const vueBuildConfig = {
    // 4
    assetsPublicPath: '/' // 资源的路径
}

// 路由 设置
const routeConfig = {
    //5
    base: '/', // 路由的路径
    //6
    mode: 'history', // history 或者 hash
}

// Api 配置
const apiConfig = {
    baseUrl: '', // 基本域名
    timeout: 5000 // 等待时长
}

// Component 配置

module.exports = {
    vueDevConfig: vueDevConfig,
    vueBuildConfig: vueBuildConfig,
    routeConfig: routeConfig,
    apiConfig: apiConfig
}


// WEBPACK FOOTER //
// ./src/configs/config.js